import type { GenerationRequestRead } from '../../types/api';
import { shapedByLine } from '../knowledge-base/brandMemory';

/**
 * "Shaped by 4 brand memories and 2 approved posts": what the copy prompt for
 * this run carried, as the request row recorded it. Nothing on a run from
 * before brand memory, one that carried neither, or one held out or run with
 * memory switched off.
 */
export function ShapedByLine({
  request,
}: {
  request: Pick<
    GenerationRequestRead,
    'brand_memory_count' | 'approved_example_count' | 'memory_arm'
  >;
}) {
  const line = shapedByLine(
    request.brand_memory_count,
    request.approved_example_count,
    request.memory_arm,
  );
  if (line === null) return null;
  return <p className="shaped-by">{line}</p>;
}
